import jwt_decode from "jwt-decode";
import dayjs from "dayjs"
import {AutoRefreshToken} from "./utils/refreshToken";

export const fetchWrapper = {
    get,
    getWithOutToken,
    post,
    login,
    put,
    delete: _delete,
    deleteBody:_deleteBody,
    putWithOutBody,
    abortTransac
};

let controller;

async function getWithOutToken(url) {
    const requestOptions = {
        method: 'GET', 
    };
    return fetch(url, requestOptions).then(handleResponse);
}

async function get(url,token) {
    const requestOptions = {
        method: 'GET',
        headers: {'Content-Type': 'application/json', 'Accept' : 'application/json', 'Authorization' : `Bearer ${token}`} 
    };
    return fetch(url, requestOptions).then(handleResponse);
}

function abortTransac() {
    controller.abort()
}

async function post(url, body, token){
    controller = new AbortController();
    const signal = controller.signal;
    var requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept' : 'application/json' },
        body: JSON.stringify(body),
        signal : signal
    };
    
    if(token){
        const user = jwt_decode(token);
        const isExpired = dayjs.unix(user.exp).diff(dayjs()) < 1;
        if(isExpired){
            token = await refreshToken(token);
        }
        requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept' : 'application/json', 'Authorization' : `Bearer ${token}` },
            body: JSON.stringify(body),
            signal : signal
        };
    }
    return fetch(url, requestOptions, 60000*5).then(handleResponse);
}

async function login(url, body) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept' : 'application/json'},
        body: JSON.stringify(body),
    };
    return fetch(url, requestOptions).then(handleResponse);
}

async function put(url, body, token) {
    const user = jwt_decode(token)
    const isExpired = dayjs.unix(user.exp).diff(dayjs()) < 1
    if(isExpired){
        token = await refreshToken(token)
    }
    const requestOptions = {
        method: 'POST',
        headers: {'Content-Type': 'application/json' , 'Accept' : 'application/json', 'Authorization' : `Bearer ${token}`},
        body: JSON.stringify(body)
    };
    return fetch(url, requestOptions).then(handleResponse);    
}

async function putWithOutBody(url,token) {
    const user = jwt_decode(token)
    const isExpired = dayjs.unix(user.exp).diff(dayjs()) < 1
    if(isExpired){
        token = await refreshToken(token)
    }
    const requestOptions = {
        method: 'PATCH',
        headers: { 'Authorization' : `Bearer ${token}`}
    };
    return fetch(url, requestOptions).then(handleResponse);    
}

async function _delete(url,token) {
    const user = jwt_decode(token)
    const isExpired = dayjs.unix(user.exp).diff(dayjs()) < 1
    if(isExpired){
        token = await refreshToken(token)
    }
    const requestOptions = {
        method: 'DELETE',
        headers: {"Authorization" : `Bearer ${token}`} 
    };
    return fetch(url, requestOptions).then(handleResponse);
}

async function _deleteBody(url, body,token) {
    const user = jwt_decode(token)
    const isExpired = dayjs.unix(user.exp).diff(dayjs()) < 1
    if(isExpired){
        token = await refreshToken(token)
    }
    const requestOptions = {
        method: 'DELETE',
        headers: {'Content-Type': 'application/json' ,"Authorization" : `Bearer ${token}`} ,
        body: JSON.stringify(body)
    };
    return fetch(url, requestOptions).then(handleResponse);
}

// helper functions

function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        
        if (!response.ok) {
            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }

        return data;
    });
}

async function refreshToken(authTokens) {
    let response = await fetch("http://localhost:8000/token/refresh/",{
        method:'POST',
        headers:{
            'Content-Type':'application/json'
        },
        body:JSON.stringify(authTokens)
    })
    let data = await response.json()
    AutoRefreshToken(data)
    return data
}